<template>
  <div class="tutorial-container">
    <!-- 侧边栏 -->
    <Sidebar class="sidebar" :menu="tutorialMenu" />
    
    <!-- 主内容区域 -->
    <div class="main-content">
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Sidebar from './components/Sidebar.vue'
import { tutorialMenu } from '@/data/tutorials'

export default {
  name: 'Tutorial',
  components: {
    Sidebar
  },
  setup() {
    return {
      tutorialMenu
    }
  }
}
</script>

<style>
.tutorial-page {
  padding: 20px;
}
.tutorial-container {
  display: flex;
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  min-height: calc(100vh - 60px);
  gap: 20px;
  padding: 20px;
  margin-top: 60px;
  box-sizing: border-box;
}

.sidebar {
  width: 130px;
  flex-shrink: 0;
  background: var(--adil-card-bg);
  border-radius: 8px;
  padding: 20px;
  height: fit-content;
  position: sticky;
  top: 80px;
  box-shadow: var(--adil-shadow-border);
}

.main-content {
  flex: 1;
  background: var(--adil-card-bg);
  border-radius: 8px;
  padding: 24px;
  min-height: calc(100vh - 100px);
  box-shadow: var(--adil-shadow-border);
  overflow-x: hidden;
}

@media (max-width: 768px) {
  .tutorial-container {
    flex-direction: column;
    padding: 10px;
    margin-top: 50px;
  }

  .sidebar {
    width: 100%;
    position: static;
    margin-bottom: 10px;
  }

  .main-content {
    min-height: auto;
    padding: 16px;
  }
}
h1 {
  font-size: 2rem;
  color: var(--adil-fontcolor);
  margin-bottom: 2rem;
  border-bottom: 2px solid var(--adil-theme);
  padding-bottom: 0.5rem;
}

h2 {
  font-size: 1.5rem;
  color: var(--adil-fontcolor);
  margin: 2rem 0 1rem;
}

h3 {
  font-size: 1.2rem;
  color: var(--adil-fontcolor);
  margin: 1rem 0;
}

.content-section {
  color: var(--adil-black);
  line-height: 1.6;
}

ul,
ol {
  margin: 1rem 0;
  padding-left: 1.5rem;
}

li {
  margin: 0.5rem 0;
}

li strong {
  color: var(--adil-fontcolor);
}

@media (max-width: 768px) {
  .tutorial-page {
    padding: 15px;
  }

  h1 {
    font-size: 1.5rem;
  }

  h2 {
    font-size: 1.25rem;
  }

  h3 {
    font-size: 1.1rem;
  }
}
</style> 